// extracted by mini-css-extract-plugin
export default {"wrapper":"gC-z","viewport":"hC-z","container":"iC-z","slide":"jC-z"};